import t from "react";
import e from "./index24.mjs";
import m from "classnames";
const _ = ({ elementId: n, errorMessage: a, value: r, onChange: i }) => /* @__PURE__ */ t.createElement("div", { "data-field": "name", className: e.stripe_input }, /* @__PURE__ */ t.createElement(
  "label",
  {
    "data-testid": "stripe-card-name-label",
    className: e.stripe_input_label,
    htmlFor: n
  },
  I18n.t("payment_frontend.card_name")
), /* @__PURE__ */ t.createElement(
  "input",
  {
    "data-testid": "stripe-card-name-input",
    dir: "ltr",
    type: "text",
    name: "name",
    id: n,
    value: r,
    onChange: (l) => i(l.target.value),
    placeholder: I18n.t("payment_frontend.cards_holder_name"),
    className: m(e.stripe_input_element, {
      [e.stripe_input_element_error]: !!a
    })
  }
), a ? /* @__PURE__ */ t.createElement(
  "div",
  {
    "data-testid": "input-stripe-error-message",
    className: e.stripe_input_error_message
  },
  a
) : null);
export {
  _ as StripeInput
};
